/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import t from"./OccludedVisibility.js";const i={type:t,json:{write:!0,default:null}};export{i as occludedVisibilityProperty};
